import React from "react";
import RowLoading from "./RowLoading.tsx";
import EmptyImage from "../../../EmptyImage.tsx";
import * as moment from "moment-timezone";
import { toCamelCase } from "../../../../hooks/toCameCase.tsx";

interface ScheduleWithoutCheck {
  schedule_id: number;
  partner_id: number;
  partner_firstName: string;
  partner_lastName: string;
  partner_secondLastName: string;
  position_name: string;
  branch_id: number;
  branch_name: string;
  exactDate: string;
  startTime: string;
  endTime: string;
  shift: string;
}

interface DayRecord {
  date: string;
  schedules: ScheduleWithoutCheck[];
}

const TableDiasSinAsistencia = ({
  records,
  loading,
  start,
  end,
}: {
  records: DayRecord[];
  loading: boolean;
  start: string;
  end: string;
}) => {
  const getShiftName = (shift: string): string => {
    const shiftMap: { [key: string]: string } = {
      Matutino: "Matutino",
      Intermedio: "Intermedio",
      Vespertino: "Vespertino",
    };
    return shiftMap[shift] || shift;
  };

  const getStartTime = (timeRange: string): string => {
    return timeRange.split(" - ")[0];
  };

  const getEndTime = (timeRange: string): string => {
    return timeRange.split(" - ")[1] || "";
  };

  return (
    <div className="table-sticky mb-3">
      <table className="table table-hover table-panel text-nowrap align-middle mb-0">
        <thead className="sticky-thead table-light text-center">
          <tr>
            <th className="align-middle">Fecha</th>
            <th className="align-middle">Chilito</th>
            <th className="align-middle">Puesto</th>
            <th className="align-middle">Turno</th>
            <th className="align-middle">Hora entrada</th>
            <th className="align-middle">Hora salida</th>
            <th className="align-middle">Sucursal</th>
          </tr>
        </thead>
        <tbody>
          {records.map((dayRecord) =>
            dayRecord.schedules.map((schedule, index) => (
              <tr key={`${dayRecord.date}-${schedule.schedule_id}-${index}`} className="text-center">
                <td>
                  {moment.utc(dayRecord.date).format("DD-MM-YYYY")}
                </td>
                <td>
                  {toCamelCase(
                    `${schedule.partner_firstName} ${schedule.partner_lastName} ${schedule.partner_secondLastName}`
                  )}
                </td>
                <td>{schedule.position_name}</td>
                <td>{getShiftName(schedule.shift)}</td>
                <td>{getStartTime(schedule.startTime)}</td>
                <td>{getEndTime(schedule.endTime)}</td>
                <td>{schedule.branch_name}</td>
              </tr>
            ))
          )}

          {loading &&
            Array.from({ length: 15 }).map((_, index) => (
              <RowLoading key={index} />
            ))}
          {!loading && records.length === 0 && (
            <tr className="text-center">
              <td colSpan={7}>
                <div className="py-4 d-flex flex-column align-items-center justify-content-center">
                  <EmptyImage className="mx-auto w-250px" />
                  <h5 className="text-secondary text-center fs-20px mt-3">
                    No se encontraron registros sin asistencia
                  </h5>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableDiasSinAsistencia;

